// ✅ src/pages/AccountSuspended.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ban, AlertTriangle } from "lucide-react";

export default function AccountSuspended() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("user") || "{}");
      setUser(stored);
    } catch {
      setUser(null);
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#0b0f1a] text-white text-center p-6">
      {/* 🔥 Suspended Badge */}
      <div className="flex items-center justify-center mb-6">
        <div className="relative">
          <Ban className="w-20 h-20 text-red-500 animate-pulse" />
          <span className="absolute inset-0 rounded-full border-4 border-red-600/50 animate-ping"></span>
        </div>
      </div>

      {/* 🧾 Main Heading */}
      <h1 className="text-4xl font-extrabold mb-2 text-red-500 drop-shadow-lg">
        🚫 Account Suspended
      </h1>

      {/* 👤 Username & Status */}
      {user?.username && (
        <p className="text-lg text-gray-300 mb-3">
          <span className="text-[#facc15] font-semibold">@{user.username}</span>
          ’s account has been temporarily disabled.
        </p>
      )}

      {/* ⚠️ Warning Text */}
      <div className="max-w-md bg-[#161c34] border border-red-700 p-4 rounded-2xl shadow-2xl mt-4">
        <AlertTriangle className="w-8 h-8 text-red-400 mx-auto mb-2" />
        <p className="text-gray-300 leading-relaxed">
          Your account has been <span className="text-red-400 font-semibold">suspended</span> 
          due to violation of our terms or suspicious activity.
        </p>
        <p className="text-yellow-400 font-medium mt-2">
          Please contact support for reactivation.
        </p>
      </div>

      {/* 📞 Support Info */}
      <div className="mt-6 text-gray-400">
        Need help?{" "}
        <a
          href="https://wa.me/8801635315625"
          target="_blank"
          rel="noreferrer"
          className="text-green-400 font-semibold hover:underline"
        >
          WhatsApp Support
        </a>
      </div>

      {/* 🔙 Back to Login */}
      <button
        onClick={() => {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          navigate("/login", { replace: true });
        }}
        className="mt-6 bg-gradient-to-r from-red-600 to-red-400 px-6 py-3 rounded-lg font-semibold hover:opacity-90 transition"
      >
        🔑 Go Back to Login
      </button>

      {/* 💫 Glow ring animation */}
      <style>{`
        @keyframes pulse-glow {
          0%, 100% { box-shadow: 0 0 10px #ff4444, 0 0 20px #ff0000; }
          50% { box-shadow: 0 0 30px #ff4444, 0 0 60px #ff0000; }
        }
      `}</style>
    </div>
  );
}